import { Button } from "@/components/ui/button";
import { Maximize2, Minimize2, Play, Square } from "lucide-react";
import { useClaude } from "@/hooks/useClaude";
import { ConsoleOutput } from "@/components/console/ConsoleOutput";

interface ChatContainerProps {
  isExpanded?: boolean;
  onToggleExpand?: () => void;
}

export function ChatContainer({ isExpanded, onToggleExpand }: ChatContainerProps) {
  const { claudeRunning, consoleLines, toggleClaude, handleInput, handleResize } = useClaude();

  return (
    <div className="flex h-full flex-col rounded-xl border border-border bg-[#1a1a2e] shadow-sm overflow-hidden">
      {/* Header */}
      <div className="flex items-center justify-between border-b border-border bg-card px-4 py-2">
        <div className="flex items-center gap-3">
          <h2 className="text-sm font-semibold">Claude Visualizer</h2>
          <Button variant={claudeRunning ? "destructive" : "default"} size="sm" onClick={toggleClaude} className="h-7 gap-1.5 text-xs">
            {claudeRunning ? (
              <>
                <Square className="h-3 w-3" />
                Stop
              </>
            ) : (
              <>
                <Play className="h-3 w-3" />
                Start
              </>
            )}
          </Button>
        </div>
        {onToggleExpand && (
          <Button variant="ghost" size="icon-xs" onClick={onToggleExpand} title={isExpanded ? "Restore split view" : "Expand"}>
            {isExpanded ? <Minimize2 className="h-3.5 w-3.5" /> : <Maximize2 className="h-3.5 w-3.5" />}
          </Button>
        )}
      </div>

      {/* Terminal Output */}
      <ConsoleOutput lines={consoleLines} onInput={handleInput} onResize={handleResize} />
    </div>
  );
}
